import { schema, types } from 'papr'

export const jwtDenyListSchema = schema(
	{
		jwt: types.string({ required: true }),
		// Removed the required because we should use the built-in field createdAt instead.
		dateAdded: types.date(),
	},
	{
		timestamps: true,
	},
)

export const createJWTDenyListIndex = async (db) => {
	await db.createIndex('jwtdenylist', { jwt: 1 }, { unique: true })
}

export type JWTDenyListDocument = (typeof jwtDenyListSchema)[0]
export type JWTDenyListSchemaOptions = (typeof jwtDenyListSchema)[1]
